// DetailsForm.tsx
import { Box, TextField, Button } from "@mui/material";
import { useDetailsForm } from "./hooks/useDetailsForm";
import { useGlobalSnackbar } from "../../../../../../../context/SnackbarContext";

export type DetailsFormValues = {
  accountHolderName: string;
  routingNumber: string;
  accountNumber?: string;
  address?: string;
};

export type DetailsFormLocationKey = "default";

type FieldKey = keyof DetailsFormValues;

interface DetailsFormProps {
  locationKey?: DetailsFormLocationKey;
  values: DetailsFormValues;
  onChange: (next: DetailsFormValues) => void;
  disabled?: boolean;
}

export const DetailsForm = ({ locationKey = "default", values, onChange, disabled = false }: DetailsFormProps) => {
  const { showSnackbar } = useGlobalSnackbar();

  const { fields, setField, saveToStorage, istouch } = useDetailsForm({
    locationKey,
    values,
    onChange,
  });

  const handleSave = () => {
    if (!istouch) return;

    saveToStorage();
  };

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      {fields.map((f) => (
        <TextField
          key={f.key}
          label={f.label}
          value={(values[f.key] ?? "") as string}
          onChange={(e) => setField(f.key as FieldKey, e.target.value)}
          required={!!f.required}
          placeholder={f.placeholder}
          helperText={f.helperText}
          disabled={disabled}
          fullWidth
          size="small"
        />
      ))}

      <Button variant="contained" onClick={handleSave} disabled={disabled || !istouch}>
        Save
      </Button>
    </Box>
  );
};
